import { render, staticRenderFns } from "./image-cropper.vue?vue&type=template&id=2afa5392&scoped=true"
import script from "./image-cropper.vue?vue&type=script&lang=ts"
export * from "./image-cropper.vue?vue&type=script&lang=ts"
import style0 from "./image-cropper.vue?vue&type=style&index=0&id=2afa5392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa5392",
  null
  
)

export default component.exports